import { loading, success, reset, handleErrorException } from 'State/actions';
import { CreateEditReceiptInventoryEnum as FieldEnum } from 'Common/FieldEnum';
import { CreateEditReceiptInventoryEnum as StatusEnum } from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';

import * as types from './types';

export const getAllSiteItems = (siteId, receiptDate, receiptId) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CREATEEDITRECEIPT_GETALLSITEITEMS_LOADING, true));

      let endpoint = `Receipt/LoadReceiptItems/${siteId}/${receiptDate}`;

      if (receiptId) {
        endpoint += `/${receiptId}`;
      }

      const response = await MPWWebApi.getGeneric(endpoint);

      dispatch(
        success(
          types.CREATEEDITRECEIPT_GETALLSITEITEMS_SUCCESS,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.CREATEEDITRECEIPT_GETALLSITEITEMS_ERROR,
          {
            Title: 'Error',
            Message: 'Unable to get site items',
          }
        )
      );
    } finally {
      dispatch(loading(types.CREATEEDITRECEIPT_GETALLSITEITEMS_LOADING, false));
    }
  };
};

export const clearGetAllSiteItemsResult = () => {
  return (dispatch) => {
    dispatch(reset(types.CREATEEDITRECEIPT_GETALLSITEITEMS_SUCCESS, []));
    dispatch(reset(types.CREATEEDITRECEIPT_GETALLSITEITEMS_ERROR, null));
  };
};

export const postSaveReceipt = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CREATEEDITRECEIPT_POSTSAVERECEIPT_LOADING, true));

      const resourceName =
        model[FieldEnum.ReceiptId] === StatusEnum.NEW
          ? 'Receipt/Create'
          : 'Receipt/Update';

      const response = await MPWWebApi.postGenericInsertUpdate(
        resourceName,
        model
      );

      dispatch(
        success(
          types.CREATEEDITRECEIPT_POSTSAVERECEIPT_SUCCESS,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.CREATEEDITRECEIPT_POSTSAVERECEIPT_ERROR,
          {
            Title: 'Error',
            Message: 'Unable to save receipt',
          }
        )
      );
    } finally {
      dispatch(loading(types.CREATEEDITRECEIPT_POSTSAVERECEIPT_LOADING, false));
    }
  };
};

export const clearPostSaveReceiptResult = () => {
  return (dispatch) => {
    dispatch(reset(types.CREATEEDITRECEIPT_POSTSAVERECEIPT_SUCCESS, null));
    dispatch(reset(types.CREATEEDITRECEIPT_POSTSAVERECEIPT_ERROR, null));
  };
};

export const getReceiptDetails = (receiptId) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(
        loading(types.CREATEEDITRECEIPT_GETRECEIPTDETAILS_LOADING, true)
      );

      const response = await MPWWebApi.getGeneric(
        `Receipt/GetReceiptDetails/${receiptId}`
      );

      dispatch(
        success(
          types.CREATEEDITRECEIPT_GETRECEIPTDETAILS_SUCCESS,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.CREATEEDITRECEIPT_GETRECEIPTDETAILS_ERROR,
          {
            Title: 'Error',
            Message: 'Unable to get receipt details',
          }
        )
      );
    } finally {
      dispatch(
        loading(types.CREATEEDITRECEIPT_GETRECEIPTDETAILS_LOADING, false)
      );
    }
  };
};

export const clearAll = () => {
  return (dispatch) => {
    dispatch(reset(types.CREATEEDITRECEIPT_CLEARALL));
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/createEditReceipt/actions.js